export default function EyeCrossedCircle({ className, backgroundColor }) {
    return (
      <svg className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="24" height="24" rx="12" fill={backgroundColor} />
          <path d="M20 11.9718C20 11.9718 16.4171 16.5432 12 16.5432C7.58286 16.5432 4 11.9718 4 11.9718C4 11.9718 7.58286 7.40039 12 7.40039C16.4171 7.40039 20 11.9718 20 11.9718Z"
                stroke="#A5A5A5"
                strokeWidth="1.5"
                strokeLinejoin="round" />
          <path d="M12.0017 14.8285C13.5796 14.8285 14.8588 13.5494 14.8588 11.9714C14.8588 10.3934 13.5796 9.11426 12.0017 9.11426C10.4237 9.11426 9.14453 10.3934 9.14453 11.9714C9.14453 13.5494 10.4237 14.8285 12.0017 14.8285Z"
                fill="#A5A5A5" />
          <path d="M7.24219 17.5865L17.5279 7.30078"
                stroke="#F2F2F2"
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round" />
          <path d="M6 16.6861L16.2857 6.40039"
                stroke="#A5A5A5"
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round" />
      </svg>
    )
}
